<template>
  <!-- <MobileRegisterLogin v-if="$store.state.mobile" /> -->
  <!-- v-else -->
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-container class="pt-0">
      <v-row>
        <v-col
          :cols="$store.state.mobile ? 12 : 8"
          :offset="$store.state.mobile ? 0 : 2"
          class="pt-0"
        >
          <v-row>
            <v-col
              cols="12"
              class="pt-0"
              :class="$store.state.mobile ? '' : 'mb-8'"
            >
              <v-row>
                <v-col cols="auto">
                  <router-link to="/">
                    <v-img
                      :src="this.$store.state.webConfig.logo"
                      :width="$store.state.mobile ? 100 : 177"
                      :height="$store.state.mobile ? 36 : 64"
                    />
                  </router-link>
                </v-col>
              </v-row>
              <v-divider />
            </v-col>
            <v-col :cols="$store.state.mobile ? 12 : 6">
              <div
                style="font-size:40px"
                class="font-medium mb-6 font-weight-bold"
              >
                <template v-if="$store.getters.languageGetter === '1'">
                  إنشاء حساب
                </template>
                <template v-else>
                  Create Account
                </template>
              </div>
              <v-text-field
                v-model="email"
                :rules="emailRules"
                type="email"
                :label="$store.getters.languageGetter === '1' ? 'البريد الإلكتروني *' : 'Email *'"
                outlined
                :dense="!$store.state.mobile"
                clearable
                required
              />
              <v-text-field
                v-model="password"
                :rules="passwordRules"
                :append-icon="eye1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="eye1 ? 'text' : 'password'"
                :label="$store.getters.languageGetter === '1' ? 'إنشاء كلمة مرورك *' : 'Create Your Password *'"
                outlined
                :dense="!$store.state.mobile"
                clearable
                required
                @click:append="eye1 = !eye1"
              />
              <v-text-field
                v-model="passwordConfirm"
                :rules="passwordConfirmRules"
                :append-icon="eye2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="eye2 ? 'text' : 'password'"
                :label="$store.getters.languageGetter === '1' ? 'المرورتأكيد كلمة *' : 'Confirm Password *'"
                outlined
                :dense="!$store.state.mobile"
                clearable
                required
                @click:append="eye2 = !eye2"
              />
              <div class="font-weight-bold mb-2">
                <template v-if="$store.getters.languageGetter === '1'">
                  بالنقر فوق "انشئ حساب" ، أوافق على ما يلي:
                </template>
                <template v-else>
                  By clicking "Create my Account" I agree that:
                </template>
              </div>
              <ul>
                <li>
                  <template v-if="$store.getters.languageGetter === '1'">
                    قد أتلقى رسائل بريد إلكتروني للتواصل حول الطلب والتسليم.
                  </template>
                  <template v-else>
                    I may receive communication emails about order and delivery.
                  </template>
                </li>
              </ul>
              <v-btn
                color="primary"
                depressed
                large
                :block="$store.state.mobile"
                class="px-12 mt-6 text-h5"
                :loading="submitting"
                @click="register"
              >
                <div class="px-4">
                  <template v-if="$store.getters.languageGetter === '1'">
                    إنشيء حسابي
                  </template>
                  <template v-else>
                    Create my Account
                  </template>
                </div>
              </v-btn>
            </v-col>
            <v-spacer />
            <v-col
              :cols="$store.state.mobile ? 12 : 3"
            >
              <v-card
                :outlined="!$store.state.mobile"
                elevation="0"
                to="/"
                class="mb-4"
                :class="$store.state.mobile ? 'text-decoration-underline' : ''"
              >
                <div
                  class="pa-4"
                  :class="$store.state.mobile ? 'pt-0 text-center' : ''"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    العودة إلى الصفحة الرئيسية
                  </template>
                  <template v-else>
                    Return to the home page
                  </template>
                </div>
              </v-card>
              <v-card
                outlined
                to="/"
                class="mb-4"
              >
                <div
                  class="pa-4"
                  :class="$store.state.mobile ? 'text-center' : ''"
                >
                  <div class="font-medium mb-4 font-weight-bold">
                    <template v-if="$store.getters.languageGetter === '1'">
                      هل لديك حساب؟
                    </template>
                    <template v-else>
                      Already have an account?
                    </template>
                  </div>
                  <v-btn
                    color="primary"
                    depressed
                    to="/login"
                  >
                    <template v-if="$store.getters.languageGetter === '1'">
                      تسجيل دخول
                    </template>
                    <template v-else>
                      Sign In Now
                    </template>
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex';
// import MobileRegisterLogin from '@/components/MobileRegisterLogin.vue';

export default {
  name: 'Register',
  components: {
    // MobileRegisterLogin,
  },
  data() {
    return {
      valid: true,
      submitting: false,
      email: '',
      emailRules: [
        (v) => !!v || 'Please enter your email',
        (v) => /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/.test(v)
          || 'This is not a correct email address',
      ],
      password: '',
      passwordRules: [
        (v) => !!v || 'Please enter your password',
        (v) => v.length >= 6 || 'Password should be more than 6 characters',
      ],
      passwordConfirm: '',
      passwordConfirmRules: [
        (v) => !!v || 'Please confirm your password',
        (v) => v === this.password || 'Passwords are not the same',
      ],
      eye1: false,
      eye2: false,
    };
  },
  created() {
  },
  methods: {
    ...mapActions(['registerAsync']),
    register() {
      if (this.$refs.form.validate()) {
        this.submitting = true;
        this.registerAsync({
          email: this.email,
          passwords: this.password,
        }).then(() => {
          this.$router.replace('/');
        }).finally(() => {
          this.submitting = false;
        });
      }
    },
  },
};
</script>
